module.exports = __webpack_public_path__ + "img/43.c1f05e43.png";